import angular from "angular";
import component from "./error-processing.component";
import form from "./form/error-processing-form.component";

let mod = angular.module('ErrorProcessing', [component, form]);

export default mod.name;




// WEBPACK FOOTER //
// ./resources/assets/modules/error-processing/error-processing.module.js